import type { ComponentProps, ReactNode } from 'react';

interface PillProps extends ComponentProps<'button'> {
  icon?: ReactNode;
  active?: boolean;
}

/** Toolbar pill button, e.g. "How to play", "Settings". */
export function Pill({ icon, active = false, className = '', children, ...rest }: PillProps) {
  return (
    <button
      type="button"
      data-active={active || undefined}
      className={[
        'inline-flex h-[42px] items-center gap-2.5 rounded-full border px-[18px] text-[12px] font-bold uppercase tracking-[0.16em]',
        'border-line-strong bg-surface transition-colors hover:border-accent hover:text-accent',
        'data-active:border-accent data-active:text-accent data-active:bg-[color-mix(in_oklch,var(--accent)_14%,var(--surface))]',
        className,
      ].join(' ')}
      {...rest}
    >
      {icon && <span className="[&>svg]:size-4">{icon}</span>}
      {children}
    </button>
  );
}
